import urlJoin from "url-join";

export const wsmKitsSectionUrlName = "/wsm/kits";

export const wsmKitListPath = `${wsmKitsSectionUrlName}/`;
export const wsmKitAddPath = urlJoin(wsmKitListPath, "add");
export const wsmKitPath = (id: string) => urlJoin(wsmKitListPath, id);
export const wsmKitUrl = (id: string) => wsmKitPath(encodeURIComponent(id));
